export { default as Img200 } from './processed/200/LeahRiminiScientology.jpg';
export { default as Img400 } from './processed/400/LeahRiminiScientology.jpg';
export { default as Imgthumb } from './processed/thumb/LeahRiminiScientology.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/LeahRiminiScientology.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/LeahRiminiScientology.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Muted": {
    "_rgb": [
      132,
      131,
      131
    ],
    "_population": 3352,
    "_hsl": [
      0,
      0.004048582995951517,
      0.5156862745098039
    ]
  },
  "LightMuted": {
    "_rgb": [
      183,
      182,
      183
    ],
    "_population": 681,
    "_hsl": [
      0.8333333333333334,
      0.006896551724137908,
      0.7156862745098039
    ]
  },
  "DarkMuted": {
    "_rgb": [
      60,
      52,
      55
    ],
    "_population": 17,
    "_hsl": [
      0.9375,
      0.07142857142857142,
      0.2196078431372549
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/LeahRiminiScientology.js